import { render, staticRenderFns } from "./docs-history.vue?vue&type=template&id=73d42faa&scoped=true"
import script from "./docs-history.vue?vue&type=script&lang=js"
export * from "./docs-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d42faa",
  null
  
)

export default component.exports